export const pathJoin = (baseUrl: string, url: string) => {
  return new URL(url, baseUrl).href;
};
